var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureSecureDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-48.4%",
    y: "-30.8%",
    width: "196.9%",
    height: "196.9%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.384313725 0 0 0 0 0.917647059 0 0 0 0 0.639215686 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.202 51.692 40.648 64.694a2.25 2.25 0 0 1-3.03-.028l-4.938-4.57a2.24 2.24 0 0 1-.72-1.566 2.235 2.235 0 0 1 .598-1.617 2.24 2.24 0 0 1 1.568-.72 2.232 2.232 0 0 1 1.615.599l3.434 3.178 13.027-11.637a2.254 2.254 0 0 1 3.18.18 2.255 2.255 0 0 1-.18 3.179m9.928-7.388a1.35 1.35 0 0 0-.825-1.198l-21.346-9a1.384 1.384 0 0 0-1.059 0l-21.346 9c-.483.204-.806.67-.826 1.195-.01.278-.774 27.837 22.261 35.042.132.041.268.063.404.063s.272-.022.403-.063C65.83 72.14 65.14 44.582 65.13 44.304",
    id: "b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.568 60.746a1.352 1.352 0 0 1-1.1-2.134c6.814-9.592 7.451-22.51 7.497-25.891l-20-8.91-20.801 9.266a1.35 1.35 0 1 1-1.1-2.468l21.346-9.51a1.386 1.386 0 0 1 1.108 0l21.347 9.51c.474.21.785.674.8 1.192.022.67.407 16.552-7.995 28.376a1.35 1.35 0 0 1-1.102.569",
    fill: "#62EAA3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#62EAA3",
    xlinkHref: "#b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureSecureDark);
export default __webpack_public_path__ + "static/media/feature-secure-dark.82f4908c4c60c2773119b1d2d29b5fe9.svg";
export { ForwardRef as ReactComponent };